export type SofpMethodChangeModalContext = {
  currentMethod: string;
  filingId: string;
  orgId: string;
  onSuccess: () => void;
};

let currentContext: SofpMethodChangeModalContext | null = null;

export const SOFP_METHOD_CHANGE_MODAL_OPEN_EVENT = 'sofpMethodChangeModal:open';
export const SOFP_METHOD_CHANGE_MODAL_CLOSE_EVENT = 'sofpMethodChangeModal:close';

export function setSofpMethodChangeModalContext(ctx: SofpMethodChangeModalContext) {
  currentContext = ctx;
}

export function getSofpMethodChangeModalContext() {
  return currentContext;
}

export function openSofpMethodChangeModal() {
  document.dispatchEvent(new CustomEvent(SOFP_METHOD_CHANGE_MODAL_OPEN_EVENT));
}

export function closeSofpMethodChangeModal() {
  document.dispatchEvent(new CustomEvent(SOFP_METHOD_CHANGE_MODAL_CLOSE_EVENT));
}
